import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dashboard } from './Dashboard';
import { showForm } from '../../store/formSlice';
import { Modal } from 'antd';
import { Title, Paragraph } from '../../components/Text';
import { Page404 } from '../../components/Page404';
import { Page403 } from '../../components/Page403';
import { OrgsIcon } from '../../icons/OrgsIcon';
import { UsersIcon } from '../../icons/UsersIcon';
// import { IssuesIcon } from '../../icons/IssuesIcon';
import { filter } from 'lodash';
import { ContractsIcon } from '../../icons/ContractsIcon';
import { UserAuditIcon } from '../../icons/UserAuditIcon';
import { UserGrantIcon } from '../../icons/UserGrantIcon';
import { ImpersonationAuditIcon } from '../../icons/ImpersonationAuditIcon';
import { resetData } from '../../store/dataSlice';
import { ShcIcon } from '../../icons/ShcIcon';
import { PackageDownloadIcon } from '../../icons/PackageDownloadIcon';
import { PackagesIcon } from '../../icons/PackagesIcon';
import { PackageAuditIcon } from '../../icons/PackageAuditIcon';
import { LicensesIcon } from '../../icons/LicensesIcon';
import { PackagePermissionsAuditIcon } from '../../icons/PackagePermissionsAuditIcon';
import { getFuturePackages, getRecentPackages } from '../../store/api/packages';
import { MainDashboardContent } from './MainDashboardContent';

const DashboardContainer = ({ location, history }) => {
    const { pathname } = location;
    const dispatch = useDispatch();
    const opened = useSelector(state => state.form.visible);
    const { hasChanges } = useSelector(state => state.form);
    const { userWrite, packageRead, packageWrite, isAdmin, auditRead, shcRead, firstLogin, fullName, grant } = useSelector(state => state.user.grants);
    const { details, loading } = useSelector(state => state.data);

    const tab = pathname.split("/")[1] || "dashboard";

    useEffect(() => {
        dispatch(resetData());
        if (tab === "dashboard" && packageRead) {
            dispatch(getRecentPackages());
            dispatch(getFuturePackages());
        };
    }, [tab, packageRead]);

    const tabs = {
        dashboard: {
            title: "Quick actions",
            actions: [
                {
                    key: "organisations",
                    title: "Add Organization",
                    icon: <OrgsIcon />,
                    enabled: isAdmin
                },
                {
                    key: "users",
                    title: "Add User",
                    icon: <UsersIcon />,
                    enabled: userWrite
                },
                // {
                //     key: "issues",
                //     title: "Add Issue",
                //     icon: <IssuesIcon />,
                //     enabled: jiraWrite
                // },
                {
                    key: "packages",
                    title: "Add Package",
                    icon: <PackagesIcon />,
                    enabled: packageWrite
                },
                {
                    key: "licenses",
                    title: "Add License",
                    icon: <LicensesIcon />,
                    enabled: isAdmin
                }
            ],
            content: packageRead ? <MainDashboardContent data={details} loading={loading} {...location} /> : null,
            onClick: (key) => onFormShow(key)
        },
        audit: {
            title: "Audit",
            actions: [
                {
                    key: "downloads",
                    title: "packages download",
                    icon: <PackageDownloadIcon />,
                    enabled: isAdmin
                },
                {
                    key: "packages",
                    title: "packages",
                    icon: <PackageAuditIcon />,
                    enabled: isAdmin
                },
                {
                    key: "permissions",
                    title: "packages permissions",
                    icon: <PackagePermissionsAuditIcon />,
                    enabled: isAdmin
                },
                {
                    key: "users",
                    title: "users",
                    icon: <UserAuditIcon />,
                    enabled: auditRead
                },
                {
                    key: "grants",
                    title: "users grants",
                    icon: <UserGrantIcon />,
                    enabled: auditRead
                },
                {
                    key: "impersonations",
                    title: "impersonations",
                    icon: <ImpersonationAuditIcon />,
                    enabled: auditRead
                },
                {
                    key: "contracts",
                    title: "organization contracts",
                    icon: <ContractsIcon />,
                    enabled: auditRead
                },
                {
                    key: "orgs",
                    title: "organizations",
                    icon: <OrgsIcon />,
                    enabled: isAdmin
                }
            ],
            onClick: (key) => history.push({pathname: pathname + "/" + key, state: { from: null }})
        },
        services: {
            title: "Services",
            actions: [
                {
                    key: "shc",
                    title: "System Health Check",
                    icon: <ShcIcon />,
                    enabled: shcRead
                }
            ],
            onClick: (key) => history.push(pathname + "/" + key + "/nodes")
        }
    };

    const onFormShow = (key) => {
        if (key !== opened) {
            if (hasChanges) {
                Modal.confirm({
                    centered: true,
                    icon: null,
                    className: "sp-confirm-modal",
                    title: <Title h4 color="#E8AF1D">Warning</Title>,
                    content: <Paragraph>Changes will not be saved. Are you sure you want to close the form?</Paragraph>,
                    okText: "Close",
                    okButtonProps: {style: { height: "40px", padding: "0px 21px", background: "var(--sp-main-color)", borderRadius: "8px", border: "none" }},
                    cancelButtonProps: {type: "link", style:{ fontSize: "14px", color: "var(--sp-main-color)" }},
                    onOk() {
                        dispatch(showForm(key));
                    },
                    onCancel() {}
                });
            } else {
                dispatch(showForm(key));
            }
        };
    };

    if (!grant) {
        return <Page403 />
    };

    return(Object.keys(tabs).indexOf(tab) < 0
        ? <Page404 />
        : <Dashboard
            {...tabs[tab]}
            tab={tab}
            actions={filter(tabs[tab].actions, { enabled: true })}
            firstLogin={firstLogin}
            fullName={fullName}
        />
    );
};

export { DashboardContainer };